export const TIMELINE_SONG_ROW_SM = 64;

export const TIMELINE_SONG_ROW_LG = 80;
